<admin-breadcrumbs></admin-breadcrumbs>

<div class="api-keys-page">
  <h3>Create API Key</h3>

  <div class="form-group" style="max-width: 400px; margin-bottom: 1rem;">
    <label>Name</label>
    <input class="form-control" [(ngModel)]="name" placeholder="e.g. Partner Integration" />
  </div>

  <div *ngIf="facilities.length > 0" class="facilities-section">
    <div class="facilities-header">
      <label>Facilities ({{ selectedFacilities.size }} selected)</label>
      <span>
        <button class="btn btn-sm btn-outline-secondary mr-1" (click)="selectAll()">Select All</button>
        <button class="btn btn-sm btn-outline-secondary" (click)="deselectAll()">Clear</button>
      </span>
    </div>
    <div class="facilities-grid">
      <label *ngFor="let f of facilities" class="facility-item" [class.selected]="selectedFacilities.has(f.fac_id)">
        <input type="checkbox" [checked]="selectedFacilities.has(f.fac_id)" (change)="toggleFacility(f.fac_id)" />
        {{ f.name }} ({{ f.fac_id }})
      </label>
    </div>
  </div>

  <button class="btn btn-primary" [disabled]="!canCreate || loading" (click)="create()">
    {{ loading ? 'Creating...' : 'Create API Key' }}
  </button>

  <div *ngIf="createdKey" class="created-key-banner">
    <strong>Save this key now — it won't be shown again.</strong>
    <div class="key-row">
      <code class="key-value">{{ createdKey }}</code>
      <button class="btn btn-sm btn-info" (click)="copyKey()">Copy</button>
    </div>
  </div>

  <h3 style="margin-top: 2rem;">API Keys</h3>

  <table *ngIf="keys.length > 0" class="table">
    <thead>
      <tr>
        <th>Name</th>
        <th>Hint</th>
        <th>Facilities</th>
        <th>Status</th>
        <th>Created</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let k of keys" [class.revoked]="!k.active">
        <td>{{ k.name }}</td>
        <td><code>****{{ k.hint }}</code></td>
        <td>{{ k.facilities?.join(', ') }}</td>
        <td>
          <span class="badge" [class.badge-success]="k.active" [class.badge-danger]="!k.active">
            {{ k.active ? 'Active' : 'Revoked' }}
          </span>
        </td>
        <td>{{ k.createdAt | date:'short' }}</td>
        <td>
          <button *ngIf="k.active" class="btn btn-sm btn-outline-danger" (click)="revoke(k)">Revoke</button>
        </td>
      </tr>
    </tbody>
  </table>
  <p *ngIf="keys.length === 0" class="text-muted text-center" style="padding: 2rem;">No API keys yet.</p>
</div>
